let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eSNL6")).then(() => parcelRequire('5YJ1A'));